import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'react-bootstrap';

const ErrorMessage = ({ isVisible, children }) => {
  if (isVisible) {
    return (
      <Alert bsStyle="danger">
        {children}
      </Alert>
    );
  }
  return null;
};

ErrorMessage.propTypes = {
  isVisible: PropTypes.bool,
  children: PropTypes.node.isRequired
};

ErrorMessage.defaultProps = {
  isVisible: false
};

export default ErrorMessage;



// WEBPACK FOOTER //
// ./src/components/Messages/ErrorMessage.jsx